import {getWindowWidth} from "../../helpers/getWindowSize";
import getSliderOffset from "../../helpers/getSliderOffset";

const swiperRaceDetails = {
    swiperInstance: null,
    init: () => {
        const mediaMatch = window.matchMedia('(min-width: 769px)');
        mediaMatch.addListener(swiperRaceDetails.breakpointCheck);
        swiperRaceDetails.breakpointCheck(mediaMatch);
    },

    breakpointCheck: (mediaMatch) => {
        // if larger viewport and multi-row layout needed
        if (mediaMatch.matches === true) {
            // clean up old instances and inline styles when available
            if ( swiperRaceDetails.swiperInstance !== null ) swiperRaceDetails.swiperInstance.destroy( true, true );
            // else if a small viewport and single column layout needed
        } else if (mediaMatch.matches === false) {
            // fire small viewport version of swiper
            return swiperRaceDetails.enableSwiper();
        }
    },

    enableSwiper: () => {
        import('swiper/bundle').then(({Swiper}) => {
            let domEls = document.querySelectorAll('.js-swiper-race-details');
            if (domEls) {
                const params = getSwiperParams();
                domEls.forEach(el => {
                    swiperRaceDetails.swiperInstance = new Swiper(el, params);
                })
            }
        })
    }
};

const getSwiperParams = () => {
    const windowWidth = getWindowWidth();
    return {
        watchOverflow: true,
        centeredSlides: true,
        spaceBetween: 32,
        slidesOffsetAfter: 16,
        slidesPerView: 'auto',
        slideToClickedSlide: true,
        resizeObserver: true,
        a11y: true,
        mousewheel: {
            forceToAxis: true
        },
        grabCursor: true,
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
            type: 'bullets',
        }
    }
}

export default swiperRaceDetails;